import { render } from "./DatosGafete.vue?vue&type=template&id=0d6a241e&scoped=true"
import script from "./DatosGafete.vue?vue&type=script&lang=js"
export * from "./DatosGafete.vue?vue&type=script&lang=js"

import "./DatosGafete.vue?vue&type=style&index=0&id=0d6a241e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6a241e"]])

export default __exports__